<script lang="ts" module>
  import type { Snippet } from 'svelte';

  // import CardHeader, { type CardHeaderProps } from './CardHeader.svelte';
  import CardLoading from './CardLoading.svelte';

  export interface AdditionalProps {
    children?: Snippet;
    header?: Snippet;
    loading?: boolean;
    hideLine?: boolean;
    class?: string;
  }

  export type BaseCardProps = AdditionalProps; // & CardHeaderProps;
</script>

<script lang="ts">
  let { hideLine: hideLineProp = false, ...props }: BaseCardProps = $props();
</script>

<div class="grid gap-4 rounded-md bg-plain p-4 font-sans shadow-card {props?.class}">
  {@render props.header?.()}
  {#if (props.loading || props.children) && props.header && !hideLineProp}
    <hr class="border-t-c-divider" />{/if}
  {#if props.loading}
    <div class="flex h-20 w-full">
      <CardLoading></CardLoading>
    </div>
  {:else}
    {@render props.children?.()}
  {/if}
</div>
